import { z } from 'zod';
import { EmailSchema } from '../common/email.schema.js';
/**
 * Client — CRM facet of the customer tenant record.
 *
 * NOTE: the same MongoDB document is surfaced as an `Organisation`
 * aggregate in the identity BC (see shared/schemas/identity/organisation.schema.ts).
 * This schema exposes the CRM-integration-facing fields: CRM provider
 * wiring (HubSpot / Swoft CRM), calendar integration, reporting &
 * notification preferences, coaching config at the tenant level.
 *
 * The frontend uses this schema on the settings & CRM admin pages.
 */
export const ActiveCrmProviderSchema = z.enum(['none', 'hubspot', 'swoft']);
export const ReportingScheduleSchema = z.enum(['none', 'weekly', 'monthly']);
export const ClientSchema = z.object({
    id: z.string(),
    email: EmailSchema,
    companyName: z.string().default(''),
    contactName: z.string().default(''),
    isActive: z.boolean().default(true),
    // Calendly
    calendlyUrl: z.string().default(''),
    calendlyApiKey: z.string().default(''),
    calendarUrl: z.string().default(''),
    // Google Calendar
    googleCalendarEnabled: z.boolean().default(false),
    googleCalendarCalendarId: z.string().default(''),
    googleCalendarAccountEmail: z.string().default(''),
    googleCalendarPreferCalendly: z.boolean().default(false),
    // HubSpot
    pushToHubspot: z.boolean().default(false),
    hubspotUseOwnConnection: z.boolean().default(false),
    // Swoft CRM
    swoftCrmEnabled: z.boolean().default(false),
    swoftCrmMode: z.enum(['cloud', 'self-hosted']).default('cloud'),
    swoftCrmUrl: z.string().default(''),
    swoftCrmTenantId: z.string().default(''),
    activeCrmProvider: ActiveCrmProviderSchema.default('none'),
    // Reporting & notifications
    reportingSchedule: ReportingScheduleSchema.default('none'),
    reportingLastSent: z.coerce.date().nullable().default(null),
    reportingRecipients: z.array(z.string()).default([]),
    notifWeeklyReportEmail: z.boolean().default(false),
    notifWeeklyReportApp: z.boolean().default(false),
    notifMonthlyGoalEmail: z.boolean().default(false),
    notifMonthlyGoalApp: z.boolean().default(false),
    notifNewMeetingEmail: z.boolean().default(true),
    notifNewMeetingApp: z.boolean().default(true),
    notifNewProspectEmail: z.boolean().default(false),
    notifNewProspectApp: z.boolean().default(false),
    // Coaching (tenant-level)
    coachingSystemPrompt: z.string().default(''),
    coachingContextDocs: z.string().default(''),
    createdDate: z.coerce.date(),
    updatedDate: z.coerce.date(),
});
//# sourceMappingURL=client.schema.js.map